import React, { memo, useState } from 'react';

const CLIENT_FIELD = 'client';
const SEARCH_FIELD = 'search';
const CONTRACTUAL_NAME_FIELD = 'contractualName';

export const columns = [CLIENT_FIELD, SEARCH_FIELD, CONTRACTUAL_NAME_FIELD];

const DisplayColumnsComponent = ({ columnApi, onHideFields }) => {
  const [values, setValues] = useState({
    [CLIENT_FIELD]: true,
    [SEARCH_FIELD]: true,
    [CONTRACTUAL_NAME_FIELD]: true,
  });

  const handleChange = key => event => {
    const { checked } = event.target;

    const newValues = {
      ...values,
      [key]: checked,
    };

    const checkedCount = Object.values(newValues).filter(Boolean).length;

    if (checkedCount === 0) {
      return;
    }

    setValues(newValues);

    columnApi.setColumnVisible(key, checked);

    const selectedFields = Object.keys(newValues).filter(k => !newValues[k]);

    onHideFields(selectedFields);
  };

  const checkedCount = Object.values(values).filter(Boolean).length;

  return (
    <div className="d-flex">
      {Object.keys(values).map(key => (
        <div key={key} className="radio-wrap radio-wrap--reverse mr10">
          <label htmlFor={key}>{key.charAt(0).toUpperCase() + key.slice(1)}</label>
          <input
            checked={values[key]}
            disabled={checkedCount === 1 && values[key]}
            id={key}
            onChange={handleChange(key)}
            type="checkbox"
          />
        </div>
      ))}
    </div>
  );
};

/** Display columns component. */
export const DisplayColumns = memo(DisplayColumnsComponent);
